import React, { useCallback, useState, useEffect, useRef } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import PostByAgg, { PostFormDataByAgg } from "../../utils/axios";
import ModalAlert from "../ModalAlert";
import LottieLoading from "./LottieLoading";
import { useAuth } from "../../context/AuthContext";
import SearchableSelect from "./SearchableSelect";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

//import { isDOMComponent } from "react-dom/test-utils";


const FormStepRilis = () => {
  const [currentStep, setCurrentStep] = useState(0);  // Mulai dengan langkah 0
  const [genre, setGenre] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState(null);
  const [selectedChannel, setSelectedChannel] = useState(null);

  const [subGenre, setSubGenre] = useState([]);
  // const [subGenreModal,setSubGenreModal] = useState([])
  // const [selectedGenreModal, setSelectedGenreModal] = useState([])
  const [selectedSubGenre, setSelectedSubGenre] = useState(null);
  const [releaseType, setReleaseType] = useState([]);
  const [selectedReleaseType, setSelectedReleaseType] = useState(null);
  const [country, setCountry] = useState([]);
  // const [selectedCountry, setSelectedCountry] = useState(null);
  const [province, setProvince] = useState([]);
  // const [selectedProvince, setSelectedProvince] = useState(null);
  const [city, setCity] = useState([]);
  // const [selectedCity, setSelectedCity] = useState(null);
  const {musicLabelCode,musicLabelName,setMusicLabelCode} = useAuth();
  const [loading, setLoading] = useState(false);
  const [modal,setModal] = useState(<div></div>);

  const [secondarySongType, setSecondarySongType] = useState(null);
  const [arranger, setArranger] = useState(null)
  const [producer, setProducer] = useState(null)
  const [remixer, setRemixer] = useState(null)
  const [composer, setComposer] = useState(null)
  const [writer, setWriter] = useState(null)

  const [trackArtistMain, setTrackArtistMain] = useState(null)
  const [trackFeaturing, setTrackFeaturing] = useState(null)
  const [genreOptions, setGenreOptions] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [subGenreOptions, setSubGenreOptions] = useState([]);
  const [secSubGenreOptions, setSecSubGenreOptions] = useState([]);
  const [releaseSubGenreOptions, setReleaseSubGenreOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);

  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate(); 

  const showSuccessModal = (messageText) => {
    setModal(
      <ModalAlert
        show={true}
        text={messageText}
        type="success"
        action={() => {
          setModal(null); // close modal saat klik OK
        }}
      />
    );
  };

  
  const showFailedModal = (messageText) => {
    setModal(
      <ModalAlert
        show={true}
        text={messageText}
        type="failed"
        action={() => {
          setModal(null); // close modal saat klik OK
        }}
      />
    );
  };
  

  const GetGenre = useCallback(() => {
    PostByAgg({
        url: 'song/v1/genre/find-by-genre-name',
        body: {
            'page': 1,
            'page_size': 200,
        },
        onResponse:onResponseGenre,
        onError:onErrorGenre
    })
  },[]);

  const [open, setOpen] = useState(false);
  const [artistData, setArtistData] = useState({
    artisname: "",
    bio: "",
    telephone: "",
    email: "",
    genre: "",
    subGenre: "",
    country: "",
    province: "",
    city: "",
    artist: []
  });

  const [artists, setArtists] = useState([])
  const [featuring,setFeaturing] = useState([])


  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setArtistData((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  const handleArtistModal = () =>{
    setOpen(true);
  }

  const handleSimpan = (e) => {
    e.preventDefault();
    setIsLoading(true); 
    // Lakukan logika penyimpanan data artis di sini (misalnya, kirim ke server)
    console.log('Data Artis yang Disimpan:', artistData);
    setOpen(false); // Tutup pop-up setelah menyimpan
    setArtistData({}); // Reset form setelah menyimpan (opsional)

    const url = 'song/v1/artist/register'

    PostByAgg({
      url: url,
      body: {
          "music_label_code" : musicLabelCode,
          "sub_genre_code" : "",
          "city_code" : artistData.city,
          "artist_name" : artistData.artisname,
          "bio" : artistData.bio,
          "image_url" : "testing image",
          "telephone" : artistData.telephone,
          "email" : artistData.email,
          "created_by" : artistData.email,
      },
      onResponse:onResponseArtist,
      onError:onErrorArtist
    })

    function onResponseArtist(response) {
      console.log("Response Artist: ", response.data.code)
      if(response.data.code === "2002000"){
        setIsLoading(false); 
        setModal(
          <ModalAlert
            show={true}
            text={response.data.message.id}
            type={"success"}
            action={() => {
              GetArtist();
            }}
          />
        )
      }else{
        setIsLoading(false); 
        setModal(
          <ModalAlert
            show={true}
            text={response.data.message.id}
            type={"failed"}
            action={() => {
            }}
          />
        )
      }
    }
    function onErrorArtist(error) {
      setIsLoading(false); 
      console.error("Error Artist: ", error);
        setModal(
          <ModalAlert
            show={true}
            text={error.response.data.message.id}
            type={"failed"}
            action={() => {
              setOpen(true)
            }}
          />
        )
    }
  };

  const handleBatal = () => {
    setOpen(false); // Tutup modal tanpa menyimpan
    // Reset form saat batal (opsional)
    setArtistData({
      artisname: "",
      bio: "",
      telephone: "",
      email: "",
      genre: "",
      subGenre: "",
      country: "",
      province: "",
      city: "",
    });
  };

  function  onResponseGenre(response) {
      console.log("Response Genre: ", response.data.data)
      if (Array.isArray(response.data.data)) {
          setGenre(response.data.data);  // Set the data correctly
      } else {
          console.error("Expected an array of countries, but got:", response.data.data);
          setGenre([]);  // If data is not in the expected format, set an empty array
      }
  }

  function  onErrorGenre(error) {
      console.log("Error Genre: ", error)
  }

  const GetSubGenre = useCallback((genreCode) =>{
      PostByAgg({
          url: 'song/v1/sub-genre/find-by-genre-code',
          body: {
              'page': 1,
              'page_size': 200,
              'genre_code':genreCode
          },
          onResponse:onResponseSubGenre,
          onError:onErrorSubGenre
      })
  },[]);

  function  onResponseSubGenre(response) {
      console.log("Response Sub Genre: ", response.data); // Debugging
      if (Array.isArray(response.data.data)) {
          setSubGenre(response.data.data)
      }
  }

  function  onErrorSubGenre(error) {
      console.log("Error Sub Genre: ", error)
  }

  const GetListChannel = useCallback(() =>{
      PostByAgg({
          url: 'song/v1/channel/list-active',
          body: {
              page: 1,
              page_size: 200,
              channel_name: ""
          },
         onResponse:(res) => {
            const mapped = res.data.data.data.map((c) => ({
              value: c.channel_code,
              label: c.channel_name
            }))
            setChannelOptions(mapped)
            console.log("mapped", mapped)
         },
          onError:(error) => {
              console.log("Error List Channel: ", error)
          }
      })
  },[]);

  useEffect(() => {
    GetListChannel();
  }, [GetListChannel]);



  const GetReleaseType = useCallback((genreCode) =>{
      PostByAgg({
          url: 'song/v1/release-type/find-by-release-type-name',
          body: {
              'release_type_name':''
          },
          onResponse:onResponseReleaseType,
          onError:onErrorReleaseType
      })
  },[]);

  function  onResponseReleaseType(response) {
      console.log("Response Release Type: ", response.data); // Debugging
      if (Array.isArray(response.data.data)) {
          setReleaseType(response.data.data)
      }
  }

  function  onErrorReleaseType(error) {
      console.log("Error Release Type: ", error)
  }

  const GetSecondarySongType = useCallback(() =>{
    PostByAgg({
        url: 'song/v1/secondary-song-type/find-by-name',
        body: {
            'secondary_song_type_name':''
        },
        onResponse:onResponseSecondarySongType,
        onError:onErrorSecondarySongType
    })
  },[]);

  function  onResponseSecondarySongType(response) {
      console.log("Response Secondary Song Type: ", response.data); // Debugging
      if (Array.isArray(response.data.data)) {
          setSecondarySongType(response.data.data)
      }
  }

  function  onErrorSecondarySongType(error) {
    console.log("Error Secondary Song Type: ", error)
  }

  const GetArranger = useCallback(() =>{
    PostByAgg({
        url: 'song/v1/arranger/find',
        body: {
            'music_label_code': musicLabelCode,
            'arranger_code':'',
            'arranger_name':''
        },
        onResponse:onResponseArranger,
        onError:onErrorArranger
    })
  },[]);

  function  onResponseArranger(response) {
      console.log("Response Arranger: ", response.data); // Debugging
      if (Array.isArray(response.data.data)) {
        const formatted = response.data.data.map((item) => ({
          value: item.arranger_code,
          label: item.arranger_name,
        }));
  
        setArranger(formatted)
      }
  }

  function  onErrorArranger(error) {
    console.log("Error Arranger: ", error)
  }

  const GetProducer = useCallback(() =>{
    PostByAgg({
        url: 'song/v1/producer/find',
        body: {
            'music_label_code':musicLabelCode,
            'producer_code':'',
            'producer_name':''
        },
        onResponse:onResponseProducer,
        onError:onErrorProducer
    })
  },[]);

  function  onResponseProducer(response) {
      console.log("Response Producer: ", response.data); // Debugging
      if (Array.isArray(response.data.data)) {
        const formatted = response.data.data.map((item) => ({
          value: item.producer_code,
          label: item.producer_name,
        }));
  
        setProducer(formatted)
      }
  }

  function  onErrorProducer(error) {
    console.log("Error Producer: ", error)
  }

  const GetRemixer = useCallback(() =>{
    PostByAgg({
        url: 'song/v1/remixer/find',
        body: {
            'music_label_code':musicLabelCode,
            'remixer_code':'',
            'remixer_name':''
        },
        onResponse:onResponseRemixer,
        onError:onErrorRemixer
    })
  },[]);

  function  onResponseRemixer(response) {
      console.log("Response Remixer: ", response.data); // Debugging
      if (Array.isArray(response.data.data)) {
        const formatted = response.data.data.map((item) => ({
          value: item.remixer_code,
          label: item.remixer_name,
        }));
  
        setRemixer(formatted)
      }
  }

  function  onErrorRemixer(error) {
    console.log("Error Remixer: ", error)
  }

  const GetWriter = useCallback(() =>{
    PostByAgg({
        url: 'song/v1/writer/find',
        body: {
            'music_label_code':musicLabelCode,
            'arranger_code':'',
            'arranger_name':''
        },
        onResponse:onResponseWriter,
        onError:onErrorWriter
    })
  },[]);

  function  onResponseWriter(response) {
      console.log("Response Wrtiter: ", response.data); // Debugging
      if (Array.isArray(response.data.data)) {
        const formatted = response.data.data.map((item) => ({
          value: item.writer_code,
          label: item.writer_name,
        }));
  
        setWriter(formatted)
      }
  }

  function  onErrorWriter(error) {
    console.log("Error Writer: ", error)
  }

  const GetComposer = useCallback(() =>{
    PostByAgg({
        url: 'song/v1/composer/find',
        body: {
            'music_label_code':musicLabelCode,
            'composer_code':'',
            'composer_name':''
        },
        onResponse:onResponseComposer,
        onError:onErrorComposer
    })
  },[]);

  function  onResponseComposer(response) {
      console.log("Response Composer: ", response.data); // Debugging
      if (Array.isArray(response.data.data)) {
        const formatted = response.data.data.map((item) => ({
          value: item.composer_code,
          label: item.composer_name,
        }));
  
        setComposer(formatted)
      }
  }

  function  onErrorComposer(error) {
    console.log("Error Composer: ", error)
  }


  const [formData, setFormData] = useState({
    RilisTerbaru: { title: "", versi: "", iInline:"",cInline: "", upcEan:"", nomorKatalog:"", mainArtist: [], featuringArtist: [], songChannel:[], genre: null, subGenre: null},
    Upload: { file: "" },
    SuntingAset: { assetTitle: "", artist: "" },
    Teritori: { country: "" },
    TanggalRilis: { releaseDate: "" },
    Promosi: { promoInfo: "" },
    TanggalPenyerahan: { submitDate: "" },
    coverImage: null
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); 
  const [payload, setPayload] = useState({});
  const [trackList, setTrackList] = useState([]);
  const [newTrack, setNewTrack] = useState({
    contentType: [],
    trackType: [],
    trackTypesong: [],
    trackTypegenisrc: [],
    mainTrackType: [],
    instruMental: [],
    secondaryTrackType: [],
    title: "",
    subtitle: "",
    trackArtistMain: [],
    trackFeaturing: [],
    remixer: [],
    composer: [],
    writer: [],
    arranger: [],
    producer: [],
    cinline: "",
    tahunProduksi: "",
    pembuat: "",
    isrc: "",
    trackGenre: null,
    trackSubGenre: null,
    trackSecGenre: null,
    trackSecSubGenre: null,
    titleLanguage: null,
    lyricLanguage: null,
    parentalGuidance: [],
    catalogNumber: "",
    lyric: "",
    iInline: ""
  });
  const [isAdding, setIsAdding] = useState(false);
  const [isAddingBulk, setIsAddingBulk] = useState(false)
  const [editingIndex, setEditingIndex] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [step, field] = name.split('.');
    setFormData((prev) => ({
      ...prev,
      [step]: {
        ...prev[step],
        [field]: value
      }
    }));
    setNewTrack((prev) => ({
      ...prev,
      [name]: value,  // Pastikan nama properti di sini sesuai dengan properti di state
    }));

    setErrors((prevErrors) => {
    const newErrors = { ...prevErrors };
    delete newErrors[name];  // Remove error for the field
    return newErrors;
  });
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    
    if (file) {
      setFormData((prev) => ({
        ...prev,
        RilisTerbaru: {
          ...prev.RilisTerbaru,
          coverImage: file
        }
      }));

      const imageUrl = URL.createObjectURL(file);
      setPreviewImage(imageUrl);
      setSelectedFile(file);
    }
  };

  const handleCancelImage = () => {
    setFormData((prev) => ({
      ...prev,
      RilisTerbaru: {
        ...prev.RilisTerbaru,
        coverImage: null
      }
    }));
    setPreviewImage(null); // Menghapus preview gambar
  };

  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [fileBulk, setFileBulk] = useState(null)  

  const fileInputBulkRef = useRef();
  
  const validateFields = () => {
    const newErrors = {};
    if (!selectedReleaseType) {
      newErrors.selectedReleaseType = 'Tipe Rilis wajib diisi';
    }
    if (!formData.RilisTerbaru.title.trim()) {
      newErrors['RilisTerbaru.title'] = 'Judul Rilis wajib diisi';
    }
    if (!formData.RilisTerbaru.versi.trim()) {
      newErrors['RilisTerbaru.versi'] = 'Versi/anak judul wajib diisi';
    }
    if (!formData.RilisTerbaru.mainArtist || formData.RilisTerbaru.mainArtist.length === 0) {
      newErrors['RilisTerbaru.mainArtist'] = 'Pilih minimal 1 artis utama';
    }
    // if (!formData.RilisTerbaru.featuringArtist || formData.RilisTerbaru.featuringArtist.length === 0) {
    //   newErrors['RilisTerbaru.featuringArtist'] = 'Pilih minimal 1';
    // }
    if (!selectedGenre) {
      newErrors.selectedGenre = "Genre wajib dipilih";
    }
    if (!selectedSubGenre) {
      newErrors.selectedSubGenre = "Sub Genre wajib dipilih";
    }
    if(!formData.RilisTerbaru.songChannel || formData.RilisTerbaru.songChannel.length === 0){
      newErrors['RilisTerbaru.songChannel'] = 'Pilih minimal 1 channel';
    }
   
    if (currentStep === 1) {
      // setShowPopup(true);
      return setModal(
        <ModalAlert
          show={true}
          status={"Konfirmasi Upload"}
          text={"Pastikan semua file telah terupload sebelum lanjut"}
          type={"confirm"}
          action={() => {
            setModal(null);
            setCurrentStep(currentStep + 1);
          }}
        />
      )
      //return
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const nextStep = () => {
    console.log("Masuk sini")
    setModal(null);
    if (validateFields()) {
      if (currentStep === 0) {
        // setShowPopup(true);
        return setModal(
          <ModalAlert
            show={true}
            status={"Konfirmasi Data"}
            text={"Pastikan semua data yang anda input sudah benar"}
            type={"confirm"}
            action={() => {
              setModal(null);
              handleCreateDirSFTP();
              setCurrentStep(currentStep + 1);
            }}
          />
        )
        //return
      }
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  

  const handleAddTrackClick = () => {
    if(selectedReleaseType == 'RT2411051517950'){
      if(trackList.length >= 1 ){
        showFailedModal('Tipe Rilis Single hanya dapat menambahkan 1 (satu) trek')
        return;
      }
    }
    

    GetSecondarySongType();
    GetArranger();
    GetComposer();
    GetProducer();
    GetRemixer();
    GetWriter();
    GetArtist();
  
    // Set form menjadi mode tambah
    setIsAdding(true);
    setEditingIndex(null);
  };

  const handleAddUploadBulk = () => {
    setIsAddingBulk(true)
  }

  const handleSaveTrack = (e) => {
    if (!newTrack.trackType || newTrack.trackType.length === 0) {
      showFailedModal("Track Type wajib dipilih.");
      return;
    }

    if (!newTrack.instruMental || newTrack.instruMental.length === 0) {
      showFailedModal("Instrumental wajib dipilih.");
      return;
    }

    if (!newTrack.title.trim()) {
      showFailedModal("Judul lagu wajib diisi.");
      return;
    }

    if (!newTrack.tahunProduksi || newTrack.tahunProduksi.length === 0) {
      showFailedModal("Tahun produksi wajib diisi.");
      return;
    }

    if (!newTrack.parentalGuidance || newTrack.parentalGuidance.length === 0) {
      showFailedModal("Bimbingan Orang tua wajib dipilih.");
      return;
    }

    const preview = newTrack.previewStart;
    if (!preview || !/^\d{2}:\d{2}$/.test(preview)) {
      showFailedModal("Format pratinjau harus MM:SS (contoh: 02:30)");
      return;
    } else {
      const [mm, ss] = preview.split(":").map(Number);
      if (isNaN(mm) || isNaN(ss) || mm < 0 || ss < 0 || ss >= 60) {
        showFailedModal("Menit atau detik tidak valid (detik < 60)");
        return;
      }
    }

    e.preventDefault();
    if (editingIndex !== null) {
      // Update data pada index yang sedang diedit
      setTrackList((prev) =>
        prev.map((track, i) => (i === editingIndex ? newTrack : track))
      );
      setEditingIndex(null);
    } else {
      // Mode Tambah data baru
      setTrackList((prev) => [...prev, newTrack]);
      
    }

    console.log("track list pas save" , trackList)
    console.log("new track", newTrack)
    // Reset form
    setNewTrack({
      contentType: [],
      trackType: [],
      trackTypesong: [],
      trackTypegenisrc: [],
      mainTrackType: [],
      instruMental: [],
      secondaryTrackType: [],
      title: "",
      subtitle: "",
    });
    setIsAdding(false);
  };

  const handleFileBulkChange = (e) => {
    const fileBulk = e.target.files[0];
    console.log("Selected file:", fileBulk); 
  if (fileBulk) {
    setFileBulk(fileBulk);
  } else {
    showFailedModal("Please select a file.");
  }
  };


  {/* tembak Upload song via excel */}
  const handleSaveTrackBulk = (e) => {
    e.preventDefault()
    setIsUploading(true);
    if (!fileBulk) {
    showFailedModal("No file selected.");
    setIsUploading(false);
    return;
  }
  
  const formData = new FormData(); 
  
  formData.append("file", fileBulk); 
  formData.append("music_label_code",String(musicLabelCode));

   for (let pair of formData.entries()) {
    console.log(pair[0], pair[1]); // Log what is being appended
  }

  PostFormDataByAgg({
    url: "song/v1/release/upload-track", 
    body: formData,
    onResponse: (res) => {
      setIsUploading(false); 
         console.log("API Response:", res);
      if (res.data.code === '2002000') {
        setUploadSuccess(true);
        showSuccessModal("Upload berhasil!"); 
        const outputData = res.data.data.map((item) => {
          return {
            contentType: [],
            trackType: [item.secondary_song_type_code], // Mapping secondary_song_type_code to trackType
            trackTypesong: [],
            trackTypegenisrc: [],
            mainTrackType: [],
            arranger: item.song_arrangers,
            catalogNumber: item.catalog_number,
            composer: item.song_composers,
            iInline: item.i_inline,
            instruMental: [item.is_instrumental.toString()],
            isrc: item.isrc,
            lyric: item.lyric,
            lyricLanguage: { value: item.lyric_language_code, label: 'Indonesia' },
            mainTrackType: [],
            parentalGuidance: [item.parental_guidance_code],
            pembuat: item.maker,
            previewStart: item.preview_start,
            producer: item.song_producers,
            remixer: item.song_remixers,
            secondaryTrackType: [],
            subtitle: item.sub_title,
            tahunProduksi: item.production_year,
            title: item.title,
            titleLanguage: { value: item.track_title_language_code, label: 'Indonesia' },
            trackArtistMain: item.song_artists,
            trackFeaturing: item.song_artist_featuring,
            trackGenre: { value: item.sub_genre_code, label: 'Genre Name' }, // Adjust this based on your data
            trackSecGenre: { value: item.secondary_sub_genre_code, label: 'Sub Genre Name' }, // Adjust as needed
            trackSecSubGenre: null, // Adjust this based on your data
            trackSubGenre: { value: item.sub_genre_code, label: 'Sub Genre Name' }, // Adjust this based on your data
            trackTypegenisrc: [],
            trackTypesong: item.song_writers,
            writer: item.song_writers
          };
        });

        console.log(outputData); 
        setTrackList(outputData)
      } else {
        setUploadError("Terjadi kesalahan saat mengupload."); 
        showFailedModal("Gagal mengupload bulk track.");
      }
    },
    onError: (err) => {
      setIsUploading(false); 
      setUploadError("Terjadi kesalahan API.");
      // showFailedModal("Gagal mengupload bulk track.");
      console.error("Error upload:", err);
    }
  });

  if (editingIndex !== null) {
      // Update data pada index yang sedang diedit
      setTrackList((prev) =>
        prev.map((track, i) => (i === editingIndex ? newTrack : track))
      );
      setEditingIndex(null);
    } else {
      // Mode Tambah data baru
      setTrackList((prev) => [...prev, newTrack]);
    }
    
    setIsAddingBulk(false);
  }

  const handleEditTrack = (index) => {
    setNewTrack({ ...trackList[index] }); // Mengisi form dengan data baris yang akan diedit
    setEditingIndex(index);
    setIsAdding(true); // Menampilkan form untuk edit
  };

  const handleDeleteTrack = (index) => {
    setTrackList((prev) => prev.filter((_, i) => i !== index));
     };

  // const handleCheckboxChange = (e, field) => {
  //   const { value, checked } = e.target;
  //   setNewTrack((prev) => ({
  //     ...prev,
  //     [field]: checked
  //       ? [...prev[field], value]
  //       : prev[field].filter((item) => item !== value),
  //   }));
  // };

  const handleCheckboxChange = (e, field) => {
    const value = e.target.value;
    setNewTrack((prev) => ({
      ...prev,
      [field]: [value], // hanya satu item di array
    }));
  };
  


  const handleReleaseTypeChange = (e) => {
    const releaseType = e.target.value;
    console.log("Selected Release Type :", releaseType);  // Debugging
     setErrors((prevErrors) => {
    const newErrors = { ...prevErrors };
    delete newErrors['selectedReleaseType'];  // Hapus error untuk field ini
    return newErrors;
  });
    setSelectedReleaseType(releaseType);// Update selected province code
  };

  const GetCountry = useCallback(() => {
          PostByAgg({
              url: 'location/v1/country/find-by-country-name',
              body: {
                  'page': 1,
                  'page_size': 200,
                  'country_name': 'Indonesia'
              },
              onResponse:onResponseCountry,
              onError:onErrorCountry
          })
  },[]);
  
      function onResponseCountry(response) {
    setLoading(false); // Set loading to false when the data is fetched
    console.log("Response Country:", response.data.data);
    if (Array.isArray(response.data.data)) {
      const formattedCountries = response.data.data.map(country => ({
          value: country.country_code,  // Misalnya 'countryCode' adalah kode negara
          label: country.country_name   // Misalnya 'countryName' adalah nama negara
      }));
      setCountry(formattedCountries);  // Update state dengan data yang terformat
    } else {
        // console.error("Expected an array of countries, but got:", response.data.data);
        setCountry([]);  // Jika data tidak dalam format yang diharapkan, set array kosong
    }
  }

  // Error handler for fetching country data
  function onErrorCountry(error) {
    setLoading(false); // Set loading to false in case of an error
    console.error("Error Country:", error);
  }
  
  
      const GetProvince = useCallback((countryCode) =>{
          PostByAgg({
              url: 'location/v1/province/find-by-country-code',
              body: {
                  'page': 1,
                  'page_size': 200,
                  'country_code':countryCode
              },
              onResponse:onResponseProvince,
              onError:onErrorProvince
          })
          // setProvince(province[countryCode] || []);
      },[]);
  
      function  onResponseProvince(response) {
          console.log("Response Province: ", response.data); // Debugging
          if (Array.isArray(response.data.data)) {
            const formattedProvinces = response.data.data.map(province => ({
                value: province.province_code,  // Misalnya 'provinceCode' adalah kode provinsi
                label: province.province_name   // Misalnya 'provinceName' adalah nama provinsi
            }));
            setProvince(formattedProvinces);  // Update state dengan data yang terformat
        } else {
            // console.error("Expected an array of provinces, but got:", response.data.data);
              setProvince([])
          }
      }
  
      function  onErrorProvince(error) {
          console.log("Error Province: ", error)
      }
  
      const GetCity = useCallback((provinceCode) => {
          PostByAgg({
              url: 'location/v1/city/find-by-province-code',
              body: {
                  'page': 1,
                  'page_size': 200,
                  'province_code':provinceCode
              },
              onResponse:onResponseCity,
              onError:onErrorCity
          })
      },[]);
  
      function  onResponseCity(response) {
          console.log("Response City: ", response.data)
          if (Array.isArray(response.data.data)) {
            const formattedCities = response.data.data.map(city => ({
                value: city.city_code,  // Misalnya 'cityCode' adalah kode kota
                label: city.city_name   // Misalnya 'cityName' adalah nama kota
            }));
            setCity(formattedCities);  // Update state dengan data yang terformat
        } else {
            // console.error("Expected an array of cities, but got:", response.data.data);
              setCity([])
        }
      }

      function  onErrorCity(error) {
        console.log("Error City: ", error)
    }

    const handleCountryChange = (countryCode) => {
      console.log("Selected Country Code:", countryCode);
      setArtistData((prevData) => ({
        ...prevData,
        country: countryCode, // Update selected country code
        province: "", // Reset province when country changes
        city: "", // Reset city when country changes
      }));
      GetProvince(countryCode); // Fetch provinces based on the selected country
    };

const handleProvinceChange = (provinceCode) => {
    console.log("Selected Province Code:", provinceCode);  // Debugging
    setArtistData((prevData) => ({
      ...prevData,
      province: provinceCode, // Update selected province code
      city: '',               // Reset city when province changes
  }));
  GetCity(provinceCode); // Fetch cities based on the selected province
};

const handleCityChange = (cityCode) => {
    console.log("Selected City Code:", cityCode);  // Debugging
    setArtistData((prevData) => ({
      ...prevData,
      city: cityCode,  // Update selected city code
  }));// Update selected city code
}


const [sftpLink, setSftpLink] = useState("");
const handleCreateRelease = () => {
  setIsLoading(true)
  const payload = {
    release_type_code: selectedReleaseType,
    sub_genre_code: selectedSubGenre.value,
    channels: formData.RilisTerbaru.songChannel.map((channel) => channel.value),
    music_label_code: musicLabelCode,
    title: formData.RilisTerbaru.title,
    sub_title: formData.RilisTerbaru.versi,
    i_inline: formData.RilisTerbaru.iInline,
    c_inline: formData.RilisTerbaru.cInline, //perlu disesuaikan di formnnya
    upload_url: sftpLink,
    created_by: musicLabelName,
    artists: formData.RilisTerbaru.mainArtist.map((artist) => artist.value),
    featuring_artists: formData.RilisTerbaru.featuringArtist.map((artist) => artist.value),
    songs: trackList.map(newTrack => ({
      secondary_song_type_code: newTrack.trackType[0],
      sub_genre_code: newTrack.trackSubGenre?.value,
      secondary_sub_genre_code: newTrack.trackSecSubGenre?.value,
      track_title_language_code: newTrack.titleLanguage?.value,
      lyric_language_code: newTrack.lyricLanguage?.value,
      is_instrumental: newTrack.instruMental[0] == "true" ? true : false,
      title: newTrack.title,
      sub_title: newTrack.subtitle,
      i_inline: newTrack.iInline, //harus dicek apakah ada atau engga
      production_year: newTrack.tahunProduksi,
      maker: newTrack.pembuat,
      isrc: newTrack.isrc,
      catalog_number: newTrack.catalogNumber,
      preview_start: newTrack.previewStart,
      lyric: newTrack.lyric,
      song_remixers: newTrack.remixer,
      song_writers: newTrack.writer,
      song_composers: newTrack.composer,
      song_arrangers: newTrack.arranger,
      song_producers: newTrack.producer,
      song_artist: newTrack.trackArtistMain,
      song_artist_featuring: newTrack.trackFeaturing,
      parental_guidance_code: newTrack.parentalGuidance[0] //belum ada di API nya
    }))
  };

  console.log("subGenre: ", newTrack.trackSecSubGenre)
  console.log("Submit Release : ")
  console.log(payload)

  console.log("JSON stringify : ")
  console.log(JSON.stringify(payload))

  PostByAgg({
    url: "song/v1/release/create",
    body: payload,
    onResponse: (res) => {
      if(res.data.data){
        const releaseCode = res.data.data.release_code;
        const releaseTitle = res.data.data.title;

        handleUploadCover(releaseCode, releaseTitle, (uploadSuccess) => {
          let message = "Release berhasil disimpan!"
          if(!uploadSuccess){
            message = "Release berhasil disimpan, cover image gagal tersimpan."
          }

          setIsLoading(false)
          setIsSubmitting(false); 
          
          return setModal(
            <ModalAlert
              show={true}
              text={message}
              type="success"
              action={() => {
                setModal(null); 
                navigate("/catalogue")
              }}
            />
          );
          
        });
      }
    },
    onError: (err) => {
      if(err.response.data){
        setIsLoading(false)
        const errorMessage = err?.response?.data?.message?.id || "Gagal menyimpan release.";
        showFailedModal(errorMessage);
        console.error("Error simpan release:", err);
        setIsSubmitting(false); // Tetap set false meskipun error
      }
    }
  });
};

const handleUploadCover = (releaseCode, releaseTitle, onDone) => {
  if (!selectedFile) {
    console.warn("No preview image selected");
    if (onDone) onDone(false); // gagal
    return;
  }

  const formData = new FormData();
  const data = {
    release_code: releaseCode,
    label_music_name: musicLabelName,
    release_name: releaseTitle,
  };

  formData.append("data", JSON.stringify(data));
  formData.append("file", selectedFile);

  PostFormDataByAgg({
    url: "song/v1/release/upload-cover",
    body: formData,
    onResponse: (response) => {
      console.log("Cover uploaded successfully:", response);

      const uploadedImageUrl = response.data.data.upload_url;
      setPayload((prevPayload) => ({
        ...prevPayload,
        upload_url: uploadedImageUrl,
      }));

      // Sukses upload cover
      if (onDone) onDone(true);
    },
    onError: (err) => {
      console.error("Error uploading cover:", err);
      // Gagal upload cover
      if (onDone) onDone(false);
    },
  });
};


const handleCreateDirSFTP = () => {
  const url = 'song/v1/release/create-sftp-directory'
  const release= formData.RilisTerbaru.title
  PostByAgg({
    url: url,
    body:{
      release_name : release,
      label_music_name: musicLabelName
    },
    onResponse: (response) => {
      setSftpLink(response.data.data.url_sftp_client);
      console.log("Directory created successfully:", response);
      // showSuccessModal("Directory SFTP berhasil dibuat!");
    },
    onError: (err) => {
      console.error("Error creating directory:", err);
      showFailedModal("Gagal membuat directory SFTP.");
    }
  })
}



const GetArtist = async () => {
  const url = 'song/v1/artist/find'
  PostByAgg({
    url: url,
    body:
      {
        "music_label_code" : musicLabelCode,
        "artist_code" : "",
        "artist_name" : ""
      },
      onResponse: onResponseGetArtist,
      onError: onErrorGetArtist
  })

  function onResponseGetArtist(response) {
    console.log("Response Artist:", response.data);
    if (Array.isArray(response.data.data)) {
      const formattedArtists = response.data.data.map(artist => ({
          value: artist.artist_code,
          label: artist.artist_name
      }));
      setArtists(formattedArtists) // Update state dengan data yang terformat
      setFeaturing(formattedArtists)

      setTrackArtistMain(formattedArtists)
      setTrackFeaturing(formattedArtists)
    } else {
        setArtists([])
    }
  }

  function onErrorGetArtist(error){
    console.log("Error:", error);
    if(error.response.data.code == "4003400"){
      setModal(
        <ModalAlert
          show={true}
          title="Error"
          message="Artist Not Found"
          action={() => {
            setOpen(false)
          }}
        />
      )
    }
  }
}


const handleFeaturingModal = () => {
  setOpen(true)
}


  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 21 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });

  const GetTrackGenre = useCallback(() => {
    PostByAgg({
      url: 'song/v1/genre/find-by-genre-name',
      body: { genre_name: '' },
      onResponse: (res) => {
        const mapped = res.data.data.map((g) => ({
          value: g.genre_code,
          label: g.genre_name,
        }));
        setGenreOptions(mapped);
      },
      onError: (err) => {
        console.error("Error fetching genre:", err);
      },
    });
  }, []);

  const GetTrackSubGenre = useCallback((genreCode, setOptionTarget) => {
    if (!genreCode) return;

    PostByAgg({
      url: 'song/v1/sub-genre/find-by-genre-code',
      body: {
        genre_code: genreCode,
        sub_genre_name: '',
      },
      onResponse: (res) => {
        const mapped = res.data.data.map((sg) => ({
          value: sg.sub_genre_code,
          label: sg.sub_genre_name,
        }));
        setOptionTarget(mapped);
      },
      onError: (err) => {
        console.error("Error fetching sub genre:", err);
      },
    });
  }, []);

  useEffect(() => {
    GetTrackGenre();
  }, [GetTrackGenre]);

  useEffect(() => {
    if (newTrack.trackGenre) {
      GetTrackSubGenre(newTrack.trackGenre.value, setSubGenreOptions);
      setNewTrack((prev) => ({ ...prev, trackSubGenre: null })); // reset
    }
  }, [newTrack.trackGenre, GetTrackSubGenre]);

  useEffect(() => {
    if (newTrack.trackSecGenre) {
      GetTrackSubGenre(newTrack.trackSecGenre.value, setSecSubGenreOptions);
      setNewTrack((prev) => ({ ...prev, trackSecSubGenre: null })); // reset
    }
  }, [newTrack.trackSecGenre, GetTrackSubGenre]);

  useEffect(() => {
    if (selectedGenre) {
      GetTrackSubGenre(selectedGenre.value, setReleaseSubGenreOptions); // fetch sub genre
      setSelectedSubGenre(null); // reset selected sub genre
    } 
  }, [selectedGenre, GetTrackSubGenre]);
  
  

  const GetTrackLanguage = useCallback(() => {
    PostByAgg({
      url: "song/v1/language/find-by-language-name",
      body: {
        language_name: "",
      },
      onResponse: (res) => {
        const mapped = res.data.data.map((lang) => ({
          value: lang.language_code,
          label: lang.language_name,
        }));
        setLanguageOptions(mapped);
      },
      onError: (err) => {
        console.error("Error fetching language:", err);
      },
    });
  }, []);

  useEffect(() => {
    GetTrackLanguage();
  }, [GetTrackLanguage]);
  

  useEffect(() => {
    GetGenre()
    GetSubGenre()
    GetReleaseType()
    GetCountry()
    GetProvince()
    GetCity()
    GetSecondarySongType()
    GetArtist()
  }, [GetGenre, GetSubGenre, GetReleaseType, GetCountry, GetProvince, GetCity, GetSecondarySongType]);

  const [openRemixer, setOpenRemixer] = useState(false);
  const [remixerFormData, setRemixerFormData] = useState({
      remixerName : ""
  });

  const handleChangeRemixerForm = useCallback((e) => {
      const { name, value } = e.target;
      setRemixerFormData((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  const handleSaveRemixerForm = () => {
    if (!remixerFormData.remixerName.trim()) {
      alert("Nama Remixer wajib diisi.");
      return;
    }

    PostByAgg({
      url: 'song/v1/remixer/register',
      body: {
        music_label_code: musicLabelCode,
        remixer_name: remixerFormData.remixerName.trim(),
      },
      onResponse: (res) => {
        console.log('Remixer berhasil disimpan:', res);
        setOpenRemixer(false);
        setRemixerFormData({ remixerName: '' });

        // Refresh daftar remixer setelah berhasil menyimpan
        GetRemixer?.();
      },
      onError: (err) => {
        const errorMessage = err?.response?.data?.message?.id || "Gagal menyimpan remixer.";
        alert(errorMessage);
        console.error("Error simpan remixer:", err);
      }
    });
  };

  const handleCancelRemixerForm = () => {
    setOpenRemixer(false); // Tutup modal tanpa menyimpan
    // Reset form saat batal (opsional)
    setRemixerFormData({
        remixerName : ""
    });
  };

  const [openWriter, setOpenWriter] = useState(false);
  const [writerFormData, setWriterFormData] = useState({
      writerName : ""
  });

  const handleChangeWriterForm = useCallback((e) => {
      const { name, value } = e.target;
      setWriterFormData((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  const handleSaveWriterForm = () => {
    if (!writerFormData.writerName.trim()) {
      alert("Nama Penulis wajib diisi.");
      return;
    }
    setIsLoading(true);

    PostByAgg({
      url: 'song/v1/writer/register',
      body: {
        music_label_code: musicLabelCode,
        writer_name: writerFormData.writerName.trim(),
      },
      onResponse: (res) => {
        setIsLoading(false);
        showSuccessModal('Penulis berhasil disimpan')
        setOpenWriter(false);
        setWriterFormData({ writerName: '' });

        // Refresh daftar writer setelah berhasil menyimpan
        GetWriter?.();
      },
      onError: (err) => {
        setIsLoading(false);
        const errorMessage = err?.response?.data?.message?.id || "Gagal menyimpan writer.";
        showFailedModal(errorMessage)
        console.error("Error simpan writer:", err);
      }
    });
  };


  const handleCancelWriterForm = () => {
      setOpenWriter(false); // Tutup modal tanpa menyimpan
      // Reset form saat batal (opsional)
      setWriterFormData({
          writerName : ""
      });
  };

  const [openComposer, setOpenComposer] = useState(false);
  const [composerFormData, setComposerFormData] = useState({
      composerName : ""
  });

  const handleChangeComposerForm = useCallback((e) => {
      const { name, value } = e.target;
      setComposerFormData((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  const handleSaveComposerForm = () => {
    if (!composerFormData.composerName.trim()) {
      alert("Nama Composer wajib diisi.");
      return;
    }

    setIsLoading(true);

    PostByAgg({
      url: 'song/v1/composer/register',
      body: {
        music_label_code: musicLabelCode,
        composer_name: composerFormData.composerName.trim(),
      },
      onResponse: (res) => {
        setIsLoading(false);
        showSuccessModal('Composer berhasil disimpan');
        setOpenComposer(false);
        setComposerFormData({ composerName: '' });

        // Refresh daftar composer setelah berhasil menyimpan
        GetComposer?.();
      },
      onError: (err) => {
        setIsLoading(false);
        const errorMessage = err?.response?.data?.message?.id || "Gagal menyimpan composer.";
        showFailedModal(errorMessage)
        console.error("Error simpan composer:", err);
      }
    });
  };

  const handleCancelComposerForm = () => {
    setOpenComposer(false); // Tutup modal tanpa menyimpan
    // Reset form saat batal (opsional)
    setComposerFormData({
        composerName : ""
    });
  };

  const [openArranger, setOpenArranger] = useState(false);
  const [arrangerFormData, setArrangerFormData] = useState({
      arrangerName : ""
  });

  const handleChangeArrangerForm = useCallback((e) => {
      const { name, value } = e.target;
      setArrangerFormData((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  const handleSaveArrangerForm = () => {
    if (!arrangerFormData.arrangerName.trim()) {
      alert("Nama Arranger wajib diisi.");
      return;
    }

    setIsLoading(true);

    PostByAgg({
      url: 'song/v1/arranger/register',
      body: {
        music_label_code: musicLabelCode,
        arranger_name: arrangerFormData.arrangerName.trim(),
      },
      onResponse: (res) => {
        setIsLoading(false);
        showSuccessModal('Arranger berhasil disimpan');
        setOpenArranger(false);
        setArrangerFormData({ arrangerName: '' });

        // Refresh daftar arranger setelah berhasil menyimpan
        GetArranger?.();
      },
      onError: (err) => {
        setIsLoading(false);
        const errorMessage = err?.response?.data?.message?.id || "Gagal menyimpan arranger.";
        showFailedModal(errorMessage)
        console.error("Error simpan arranger:", err);
      }
    });
  };

  const handleCancelArrangerForm = () => {
      setOpenArranger(false); // Tutup modal tanpa menyimpan
      // Reset form saat batal (opsional)
      setArrangerFormData({
          arrangerName : ""
      });
  };

  const [openProducer, setOpenProducer] = useState(false);
  const [producerFormData, setProducerFormData] = useState({
      producerName : ""
  });

  const handleChangeProducerForm = useCallback((e) => {
      const { name, value } = e.target;
      setProducerFormData((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  const handleSaveProducerForm = () => {
    if (!producerFormData.producerName.trim()) {
      alert("Nama Producer wajib diisi.");
      return;
    }

    setIsLoading(true);

    PostByAgg({
      url: 'song/v1/producer/register',
      body: {
        music_label_code: musicLabelCode,
        producer_name: producerFormData.producerName.trim(),
      },
      onResponse: (res) => {
        setIsLoading(false);
        showSuccessModal('Producer berhasil disimpan');
        setOpenProducer(false);
        setProducerFormData({ producerName: '' });

        // Refresh daftar producer setelah berhasil menyimpan
        GetProducer?.();
      },
      onError: (err) => {
        setIsLoading(false);
        const errorMessage = err?.response?.data?.message?.id || "Gagal menyimpan producer.";
        showFailedModal(errorMessage)
        console.error("Error simpan producer:", err);
      }
    });
  };

  const handleCancelProducerForm = () => {
      setOpenProducer(false); // Tutup modal tanpa menyimpan
      // Reset form saat batal (opsional)
      setProducerFormData({
          producerName : ""
      });
  };

  const renderPreview = () => (
    <div className="preview-container">
      <h5 className="text-md">Preview of All Data:</h5>
      <br />
      <h6 className="text-md">Rilis</h6>
      <div className="preview-content">
        <div className="row gy-3">
          <div className="col-sm-6">
            <table className="text-sm text-secondary-light">
              <tbody>
                <tr>
                  <td>Judul Rilis</td>
                  <td className="ps-5">: {formData.RilisTerbaru.title || '-'}</td>
                </tr>
                {/* <tr>
                  <td style={{ verticalAlign: "top" }}>Artis Utama</td>
                  <td className="ps-5">
                    <div className="d-flex flex-column">
                      {formData.RilisTerbaru.mainArtist.length > 0 ? (
                        formData.RilisTerbaru.mainArtist.map((artist, idx) => (
                          <span
                            key={idx}
                            className={idx === 0 ? "" : "ps-4"} // padding left hanya untuk baris setelah :
                          >
                            {idx === 0 ? `: ${artist.label}` : artist.label}
                          </span>
                        ))
                      ) : (
                        <span>-</span>
                      )}
                    </div>
                  </td>
                </tr> */}
                <tr>
                  <td>Artis Utama</td>
                  <td className="ps-5">
                    : {formData.RilisTerbaru.mainArtist.length > 0
                        ? formData.RilisTerbaru.mainArtist.map((artist) => artist.label).join(", ")
                        : '-'}
                  </td>
                </tr>
                <tr>
                  <td>Genre</td>
                  <td className="ps-5">: {selectedGenre?.label || '-'}</td>
                </tr>
                <tr>
                  <td>P line</td>
                  <td className="ps-5">: {formData.RilisTerbaru.iInline || '-'}</td>
                </tr>
                <tr>
                  <td>Cover Image</td>
                  <td className="ps-5">:
                    {selectedFile ?<div><img src={URL.createObjectURL(selectedFile)} alt="Cover" style={{ maxWidth: '150px' }} /></div> : ' No image uploaded'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-6">
            <table className="text-sm text-secondary-light">
              <tbody>
                <tr>
                  <td>Versi/Anak Judul</td>
                  <td className="ps-5">: {formData.RilisTerbaru.versi || '-'}</td>
                </tr>
                <tr>
                  <td>Featuring</td>
                  <td className="ps-5">
                    : {formData.RilisTerbaru.featuringArtist.length > 0
                        ? formData.RilisTerbaru.featuringArtist.map((artist) => artist.label).join(", ")
                        : '-'}
                  </td>
                </tr>
                <tr>
                  <td>Sub Genre</td>
                  <td className="ps-5">: {selectedSubGenre?.label || '-'}</td>
                </tr>
                <tr>
                  <td>Channel</td>
                  <td className="ps-5">
                    : {formData.RilisTerbaru.songChannel.length > 0
                        ? formData.RilisTerbaru.songChannel.map((artist) => artist.label).join(", ")
                        : '-'}
                  </td>
                </tr>
                <tr>
                  <td>C line</td>
                  <td className="ps-5">: {formData.RilisTerbaru.cInline || '-'}</td>
                </tr>
                

              </tbody>
            </table>
          </div>
        </div>
      </div>

      <br />
      <h6 className="text-md">Upload URL</h6>
      <div className="preview-content">
        <div className="row gy-3">
          
          <div>{sftpLink}</div>
        </div>
        
      </div>

      <br />
      <h6 className="text-md">List Trek</h6>
      <div className="preview-content">
        <div className="row gy-3">
        {trackList.length === 0 ? (
          <div>Tidak ada trek</div>
        ) : (
          
          <div>
            <table className="table bordered-table text-sm">
              <thead>
                <tr className="">
                  <th className="text-sm">No</th>
                  <th className="text-sm">Judul</th>
                  <th className="text-sm">Versi/Anak Judul</th>
                  <th className="text-sm">Tahun Produksi</th>
                  <th className="text-sm">Pembuat</th>
                  <th className="text-sm">ISRC</th>
                  <th className="text-sm">Nomor Katalog</th>
                  <th className="text-sm">Pratinjau </th>
                </tr>
              </thead>
              <tbody>
                {trackList.map((track, index) => (
                  <tr key={index}>
                    <td className="text-start">{index + 1}</td>
                    <td className="text-start">{track.title}</td>
                    <td className="text-start">{track.subtitle}</td>
                    <td className="text-start">{track.tahunProduksi}</td>
                    <td className="text-start">{track.pembuat}</td>
                    <td className="text-start">{track.isrc}</td>
                    <td className="text-start">{track.catalogNumber}</td>
                    <td className="text-start">{track.previewStart}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
          
      </div>
       
      </div>
    </div>
  );

  


  return (
    <div className="col-md-12">
      <div className="card">
        <div className="card-body">
          <h6 className="mb-4 text-xl">Rilis</h6>
          <p className="text-neutral-500">
            Fill up your details and proceed to the next steps.
          </p>
          {/* Form Wizard Start */}
          <div className="form-wizard">
            <form action="#" onSubmit={(e) => e.preventDefault()}>
              <div className="form-wizard-header overflow-x-auto scroll-sm pb-8 my-32">
                <ul className="list-unstyled form-wizard-list style-two">
                {/* {['Rilis Terbaru', 'Upload', 'Sunting Asset', 'Teritori', 'Tanggal Rilis', 'Promosi', 'Tanggal Penyerahan', 'Preview'].map((step, index) => ( */}
                  {['Rilis Terbaru', 'Upload', 'Sunting Asset', 'Preview'].map((step, index) => (
                    <li
                      key={index}
                      className={`form-wizard-list__item ${currentStep >= index && "activated"} ${currentStep === index && "active"}`}
                    >
                      <div className="form-wizard-list__line">
                        <span className="count">{index + 1}</span>
                      </div>
                      <span className="text text-xs fw-semibold">{step}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Rilis Terbaru Step */}
              <fieldset className={`wizard-fieldset ${currentStep === 0 && "show"}`}>
                <h6 className="text-md text-neutral-500">Rilis Terbaru</h6>
                <div className="row gy-3">
                  {/* Release Type */}
                  <div className="col-sm-6 w-100" style={{marginBottom: '10px'}}>
                    <label className="form-label">Release Type*</label>
                    <select 
                        className={`form-select wizard-required ${errors?.['selectedReleaseType'] ? 'is-invalid' : ''}`}
                        onChange={handleReleaseTypeChange}
                        defaultValue={selectedReleaseType || ''}>
                      <option value="">Select Release Type</option>
                        {
                            releaseType.length > 0 ? (
                              releaseType.map((item, index) => (
                                    <option key={index} value={item.release_type_code}>{item.release_type_name}</option>
                                ))
                            ) : (
                                <option>No options available</option>
                            )
                        }
                        
                    </select>
                    {/* Error Message */}
                    {errors?.['selectedReleaseType'] && (
                      <div className="text-danger">{errors['selectedReleaseType']}</div>
                    )}
                  </div>
                </div>

                <div className="row gy-3">
                  {/* Release Type */}
                  <div className="row col-sm-6 w-100">
                      {previewImage ? (
                            <div className="col-sm-12 mt-3 text-center" style={{ position: "relative" }}>
                              <h6 className="form-label">Preview Cover Image</h6>
                              <img
                                src={previewImage}
                                alt="Cover Preview"
                                className="img-fluid"
                                style={{ maxWidth: '150px' }}
                              />
                              {/* Tombol Cancel (X) */}
                              <button
                                  type="button"
                                  onClick={handleCancelImage}
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    right: "0",
                                    background: "red",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "30px",
                                    height: "30px",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                  }}
                                >
                                  <Icon icon="mdi:close" style={{ fontSize: "18px" }} />
                              </button>
                            </div>
                          ) : (
                            // Placeholder for no preview image
                            <div className="col-sm-6 mt-3 w-100" style={{ border: '1px dashed #ccc', padding: '10px', marginLeft: '12px', textAlign: 'center' }}>
                              <h6 className="form-label">No Preview Available</h6>
                              <p style={{ color: '#888' }}>Upload an image to preview</p>
                            </div>
                          )}
                      <div className="col-sm-12 d-flex flex-column align-items-center">
                        <label className="form-label">Cover Image*</label>
                        <input
                          type="file"
                          className="form-control wizard-required w-auto"
                          name="RilisTerbaru.coverImage"
                          onChange={handleFileChange}
                        />
                      </div>
                  </div>
                </div>

                <div className="row gy-3">
                  
                  {/* Judul Rilis */}
                  <div className="col-sm-6">
                    <label className="form-label">Judul Rilis*</label>
                    <input
                      type="text"
                      className={`form-control wizard-required ${errors?.['RilisTerbaru.title'] ? 'is-invalid' : ''}`}
                      placeholder="Enter Judul Rilis"
                      name="RilisTerbaru.title"
                      value={formData.RilisTerbaru.title}
                      onChange={handleInputChange}
                      required
                    />
                    {/* Error Message */}
                    {errors?.['RilisTerbaru.title'] && (
                      <div className="text-danger">{errors['RilisTerbaru.title']}</div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Versi/Anak Judul*</label>
                    <input
                      type="text"
                      className={`form-control wizard-required ${errors?.['RilisTerbaru.versi'] ? 'is-invalid' : ''}`}
                      placeholder="Enter Versi/Anak Judul"
                      name="RilisTerbaru.versi"
                      value={formData.RilisTerbaru.versi}
                      onChange={handleInputChange}
                      required
                    />
                    {/* Error Message */}
                    {errors?.['RilisTerbaru.versi'] && (
                      <div className="text-danger">{errors['RilisTerbaru.versi']}</div>
                    )}
                  </div>

                  {/* Artis Utama */}
                    <div className="col-sm-6">
                      <div className="row">
                        <label className="form-label">Artis Utama*</label>
                        <div className="w-100 d-flex align-items-center">
                          <div className="w-100 me-2"> 
                            <Select
                              isMulti
                              name="mainArtist"
                              options={artists || []}
                              isLoading={!artists}
                              placeholder="Select Artist Utama"
                              // value={
                              //   (formData.RilisTerbaru?.mainArtist || []).map((val) =>
                              //     (artists || []).find((opt) => opt.value === val)
                              //   ).filter(Boolean)
                              // }
                              value={formData.RilisTerbaru?.mainArtist || []}
                              onChange={(selectedOptions) => {

                                setErrors((prevErrors) => {
                                const newErrors = { ...prevErrors };
                                delete newErrors['RilisTerbaru.mainArtist'];  // Menghapus error untuk field mainArtist
                                return newErrors;
                              })
                                setFormData((prev) => ({
                                  ...prev,
                                  RilisTerbaru: {
                                    ...prev.RilisTerbaru,
                                    //mainArtist: selectedOptions.map((opt) => opt.value),
                                    mainArtist: selectedOptions,
                                  },
                                }))
                               }
                              }
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: 'white',
                                  borderColor: errors["RilisTerbaru.mainArtist"] ? '#dc2626' : '#d1d5db', // red-600 or gray-300
                                  boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none', // blue-500
                                  '&:hover': {
                                    borderColor: errors["RilisTerbaru.mainArtist"] ? '#dc2626' : '#9ca3af', // red-600 or gray-400
                                  },
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: '#e0f2fe', // light blue
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: '#0369a1', // darker blue
                                }),
                              }}

                            />
                            {/* Error Message */}
                            {errors?.['RilisTerbaru.mainArtist'] && (
                              <div className="text-danger">{errors['RilisTerbaru.mainArtist']}</div>
                            )}
                          </div>
                          <button
                            type="button"
                            style={{
                              outline: 'none',
                              fontWeight: 'bold',
                              fontSize: '27px',
                              borderRadius: '20%',
                              backgroundColor: '#487fff',
                              color: 'white',
                              width: '46px',
                              height: '42px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            onClick={handleArtistModal}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                    
                  {/* Featuring */}
                  <div className="col-sm-6">
                    <label className="form-label">Featuring</label>
                      <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="w-100 me-2"> 
                        <Select
                          isMulti
                          name="featuringArtist"
                          options={featuring || []}
                          isLoading={!featuring}
                          placeholder="Select Featuring"
                          value={formData.RilisTerbaru?.featuringArtist || []}
                          onChange={(selectedOptions) =>
                            setFormData((prev) => ({
                              ...prev,
                              RilisTerbaru: {
                                ...prev.RilisTerbaru,
                                featuringArtist: selectedOptions,
                              },
                            }))
                          }
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: 'white',
                              borderColor: errors["RilisTerbaru.featuringArtist"] ? '#dc2626' : '#d1d5db', // red-600 or gray-300
                              boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                              '&:hover': {
                                borderColor: errors["RilisTerbaru.featuringArtist"] ? '#dc2626' : '#9ca3af', // red-600 or gray-400
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: '#e0f2fe', // light blue
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: '#0369a1', // darker blue
                            }),
                          }}
                        />
                      </div>
                        <button
                          type="button"
                          style={{
                            outline: 'none',
                            fontWeight: 'bold',
                            fontSize: '27px',
                            borderRadius: '20%',
                            backgroundColor: '#487fff',
                            color: 'white',
                            width: '46px',
                            height: '42px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                          onClick={handleFeaturingModal}
                        >
                          +
                        </button>
                      </div>
                  </div>
                  {open && (
                      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50 transition-all duration-300 ease-out animate-fadeIn">
                        <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-3xl p-6 relative transform transition-all scale-95 hover:scale-100 duration-300">
                          <h2 className="text-2xl font-bold mb-4 mt-5 text-center">Tambah Artis</h2>
                          <form className="overflow-y-auto space-y-4 pr-2 p-5">
                            {/* Input Fields */}
                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                                <div className="col-md-6">
                                  <label className="form-label">Artis Name</label>
                                  <input
                                    type="text"
                                    name="artisname"
                                    value={artistData.artisname}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Artist Name"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Bio</label>
                                  <input
                                    type="text"
                                    name="bio"
                                    value={artistData.bio}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Bio"
                                  />
                                </div>
                              </div>
                            </div>
                            {/* Additional Fields */}
                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                                <div className="col-md-6">
                                  <label className="form-label">Email</label>
                                  <input
                                    type="text"
                                    name="email"
                                    value={artistData.email}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Email"
                                  />
                                </div>
                                {/* <div className="col-md-6">
                                  <label className="form-label">Genre</label>
                                  <input
                                    type="text"
                                    name="genre"
                                    value={artistData.genre}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Genre"
                                  />
                                </div> */}
                                <div className="col-md-6">
                                  <label className="form-label">Phone</label>
                                  <input
                                    type="number"
                                    name="telephone"
                                    value={artistData.phone}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="phone"
                                  />
                                </div>
                              </div>
                            
                            {/* More Fields */}
                            <div className="row gap-3">
                              <div className="d-flex gap-3 col-md-12">
                                {/* <div className="col-md-6">
                                  <label className="form-label">Sub Genre</label>
                                  <select className='form-select wizard-required'
                                      onChange={handleSubGenreChange}
                                      defaultValue={selectedGenreModal || ''}>
                                    <option value="">Select Sub Genre</option>
                                      {
                                          subGenreModal.length > 0 ? (
                                            subGenreModal.map((item, index) => (
                                                  <option key={index} value={item.sub_genre_code}>{item.sub_genre_name}</option>
                                              ))
                                          ) : (
                                              <option>No options available</option>
                                          )
                                      }
                                      
                                  </select>
                                </div> */}
                                <div className="col-md-6">
                                  <label className="form-label">Country</label>
                                 {loading ? (
                                    <p>Loading countries...</p>
                                  ) : (
                                    <SearchableSelect 
                                    data={country} 
                                    onChange={handleCountryChange}
                                    placeholder="Select Country"
                                    showBadges={false}
                                    required
                              />
                                  )}
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Province</label>
                                  {loading ? (
                                    <p>Loading countries...</p>
                                  ) : (
                                    <SearchableSelect 
                                    data={province} 
                                    onChange={handleProvinceChange}
                                    placeholder="Select Province"
                                    showBadges={false}
                                    disabled={!artistData.country}
                              />
                                  )}
                                </div>
                              </div>
                            </div>
                            </div>
                            {/* Location Fields */}
                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                                <div className="col-md-6">
                                  <label className="form-label">City</label>
                                  {loading ? (
                                    <p>Loading countries...</p>
                                  ) : (
                                    <SearchableSelect 
                                    data={city} 
                                    onChange={handleCityChange}
                                    placeholder="Select City"
                                    showBadges={false}
                                    disabled={!artistData.province}
                              />
                                  )}
                                </div>
                              </div>
                            </div>
                            {/* Buttons */}
                            <div className="d-flex justify-content-end gap-4 mt-10 pt-20 pb-12">
                              <button
                                type="button"
                                onClick={handleBatal}
                                className="btn w-100"
                                style={{ backgroundColor: "#1f1f20", color: "white" }}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                onClick={handleSimpan}
                                className="btn w-100"
                                style={{ backgroundColor: "#487fff", color: "white" }}
                              >
                                Save
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                  {/* Genre */}
                  <div className="col-md-6">
                    <label className="form-label">Genre*</label>
                    <Select
                      options={genreOptions}
                      value={selectedGenre}
                      onChange={(selected) => {
                        setErrors((prevErrors) => {
                          const newErrors = { ...prevErrors };
                          delete newErrors["selectedGenre"];  // Menghapus error terkait Genre
                          return newErrors;
                        });

                        setSelectedGenre(selected);
                    
                        // Jika user mengklik clear (hapus pilihan genre)
                        if (!selected) {
                          setSelectedSubGenre(null);  // reset sub genre
                          setSubGenre([]);            // reset options sub genre juga (opsional)
                        }
                      }}                    
                      placeholder="Select Genre"
                      isClearable
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          backgroundColor: 'white',
                          borderColor: errors["selectedGenre"] ? '#dc2626' : '#d1d5db', // red-600 or gray-300
                          boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                          '&:hover': {
                            borderColor: errors["selectedGenre"] ? '#dc2626' : '#9ca3af', // red-600 or gray-400
                          },
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: '#e0f2fe', // light blue
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: '#0369a1', // darker blue
                        }),
                      }}
                    />
                    {/* error message */}
                    {errors["selectedGenre"] && (
                      <p className="text-danger">{errors["selectedGenre"]}</p>
                    )}
                  </div>

                  {/* Sub Genre */}
                  <div className="col-md-6">
                    <label className="form-label">Sub Genre*</label>
                    <Select
                      options={releaseSubGenreOptions}
                      value={selectedSubGenre}
                      onChange={(selected) => {
                        setErrors((prevErrors) => {
                          const newErrors = { ...prevErrors };
                          delete newErrors["selectedSubGenre"];  // Menghapus error terkait Genre
                          return newErrors;
                        })
                        setSelectedSubGenre(selected)
                       }
                      }
                      placeholder="Select Sub Genre"
                      isClearable
                      isDisabled={!selectedGenre}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          backgroundColor: 'white',
                          borderColor: errors["selectedSubGenre"] ? '#dc2626' : '#d1d5db', // red-600 or gray-300
                          boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                          '&:hover': {
                            borderColor: errors["selectedSubGenre"] ? '#dc2626' : '#9ca3af', // red-600 or gray-400
                          },
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: '#e0f2fe', // light blue
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: '#0369a1', // darker blue
                        }),
                      }}
                    />
                    {/* error message */}
                    {errors["selectedSubGenre"] && (
                      <p className="text-danger">{errors["selectedSubGenre"]}</p>
                    )}
                  </div>

                  {/* Channel */}
                  <div className="col-md-6">
                    <label className="form-label">Channel*</label>
                    <Select
                      isMulti
                      name="songChannel"
                      options={channelOptions || []}
                      placeholder="Select Channel"
                      value={formData.RilisTerbaru?.songChannel || []}
                      onChange={(selectedOptions) => {
                        setErrors((prevErrors) => {
                                const newErrors = { ...prevErrors };
                                delete newErrors['RilisTerbaru.songChannel'];  // Menghapus error untuk field mainArtist
                                return newErrors;
                              })
                        setFormData((prev) => ({
                          ...prev,
                          RilisTerbaru: {
                            ...prev.RilisTerbaru,
                            //mainArtist: selectedOptions.map((opt) => opt.value),
                            songChannel: selectedOptions,
                          },
                        }))
                      }}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          backgroundColor: 'white',
                          borderColor: errors["RilisTerbaru.songChannel"] ? '#dc2626' : '#d1d5db', // red-600 or gray-300
                          boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                          '&:hover': {
                            borderColor: errors["RilisTerbaru.songChannel"] ? '#dc2626' : '#9ca3af', // red-600 or gray-400
                          },
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: '#e0f2fe', // light blue
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: '#0369a1', // darker blue
                        }),
                      }}
                    />
                    {/* error message */}
                    {errors["RilisTerbaru.songChannel"] && (
                      <p className="text-danger">{errors["RilisTerbaru.songChannel"]}</p>
                    )}
                  </div>

                  {/* Label */}
                  <div className="col-sm-6">
                    <label className="form-label">P line</label>
                    <input
                      type="text"
                      className="form-control wizard-required"
                      placeholder="Enter P line"
                      name="RilisTerbaru.iInline"
                      value={formData.RilisTerbaru.iInline}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="col-sm-6">
                    <label className="form-label">C line</label>
                    <input
                      type="text"
                      className="form-control wizard-required"
                      placeholder="Enter C Inline"
                      name="RilisTerbaru.cInline"
                      value={formData.RilisTerbaru.cInline}
                      onChange={handleInputChange}
                    />
                  </div>
                   
                  {/* UPC/EAN */}
                  {/* <div className="col-sm-6">
                    <label className="form-label">UPC/EAN*</label>
                    <input
                      type="text"
                      className="form-control wizard-required"
                      placeholder="Enter UPC/EAN"
                      name="RilisTerbaru.upcEan"
                      value={formData.RilisTerbaru.upcEan}
                      onChange={handleInputChange}
                    />
                  </div> */}
                  {/* Nomor Katalog */}
                  {/* <div className="col-sm-6">
                    <label className="form-label">Nomor Katalog*</label>
                    <input
                      type="text"
                      className="form-control wizard-required"
                      placeholder="Enter Nomor Katalog"
                      name="RilisTerbaru.nomorKatalog"
                      value={formData.RilisTerbaru.nomorKatalog}
                      onChange={handleInputChange}
                    />
                  </div> */}
                </div>
              </fieldset>


              {/* Upload Step */}
              <fieldset className={`wizard-fieldset ${currentStep === 1 && "show"}`}>
                <h6 className="text-md text-neutral-500">Upload</h6>
                <div className="row gap-3">
                 
                  {/* Card Layout for FTP Upload */}
                  <div className="container mt-4">
                    <div className="row justify-content-center ">
                        {/* Pilih Opsi */}
                        <div className="bg-dark text-white pt-3 pb-3 px-5 rounded">
                          <h3 className="h6 font-weight-bold">Pilih Opsi</h3>
                          <p className="text-white">Pilih metode untuk upload file</p>
                          <div className="d-flex gap-3 mt-3">
                            <button
                              type="button"
                              className="btn btn-danger w-25"
                            >
                              Import Via Web Browser
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-secondary w-25"
                            >
                              Uploader
                            </button>
                          </div>
                        </div>
                        {/* FTP Instructions Card */}
                        <div className="bg-dark text-white pt-3 pb-5 px-5 mt-4 rounded">
                        <p className="font-semibold text-white text-xl">• Silakan klik link/url dibawah ini untuk melakukan upload.</p>

                          <div className="bg-transparent rounded pt-3 pb-0 px-5 mt-2">
                            <div className="d-flex justify-content-between">
                             <div className="col-8 d-flex align-items-center gap-2 flex-wrap">
                              <p className="font-weight-bold text-white mb-0">URL:</p>
                              <a
                                href={sftpLink}
                                target="_blank"
                                rel="noreferrer"
                                className="path-upload text-blue"
                              >
                                {sftpLink}
                              </a>
                              </div>
                              {/* <div className="col-6">
                                <p className="font-weight-bold text-white">Port:</p>
                                <p className="text-white">22</p>
                              </div> */}
                            </div>
                          
                            {/* <div className="d-flex justify-content-between mt-3">
                              <div className="col-6">
                                <p className="font-weight-bold text-white">Login:</p>
                                <p className="text-white">example_user</p>
                              </div>
                              <div className="col-6">
                                <p className="font-weight-bold text-white">Kata Sandi:</p>
                                <p className="text-white">*****</p>
                              </div>
                            </div> */}
                          </div>
                            <p className="text-red font-weight-semibold pt-3 pb-0 px-3 fst-italic">
                              • Link tersebut dapat diakses ketika anda berhasil melakukan submit.
                            </p>
                            <p className="font-semibold text-white text-xl">
                              • Jika anda pertama kali melakukan login/upload silakan download step by step di bawah ini sebagai langkah agar aktivasi akun dapat baik dan benar.
                            </p>
                            <div className="bg-transparent pt-3 pb-3 px-5 rounded mt-2">
                            <div className="d-flex justify-content-between">
                             <div className="col-8 d-flex align-items-center gap-2 flex-wrap">
                              <p className="text-white mb-0">DOC:</p>
                              <a
                                href={`https://files.orbitdigitalentertainment.com/web/client/pubshares/dmAWSCm3CfwRrCCbJY5Sr8/?compress=false`}
                                target="_blank"
                                rel="noreferrer"
                                className="path-upload text-blue"
                              >
                                {`Step by Step Setup 2FA and Change Password Upload File`}
                              </a>
                              </div>
                            </div>
                          </div>
                            <p className="font-semibold text-white text-xl">
                              • Jika sudah melakukan setup keamanan dan change password silakan login dengan user dan password yang sudah terdaftar.
                            </p>
                        </div>
                        {showPopup && (
                          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white rounded-lg p-6 shadow-lg max-w-md w-full text-center">
                              <h2 className="text-lg font-semibold mb-4">Konfirmasi Upload!</h2>
                              <p className="font-semibold text-xl mb-4">Pastikan semua file telah terupload sebelum lanjut.</p>
                              <div className="flex justify-center gap-4">
                              <div className="flex justify-center gap-4 pt-6 pb-6">
                                  <button
                                    type="button"
                                    onClick={() => setShowPopup(false)}
                                    className="px-3 py-2 rounded font-medium"
                                    style={{ backgroundColor: "#1f1f20", color: "white" }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setShowPopup(false);
                                      setCurrentStep(currentStep + 1);
                                    }}
                                    className="px-3 py-2 rounded font-medium"
                                    style={{ backgroundColor: "#487fff", color: "white" }}
                                  >
                                    Lanjut
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* File Format Options Card */}
                         <div className="bg-dark text-white pt-3 pb-3 px-5 mt-4 rounded">
                            <p className="font-weight-semibold pb-3 mb-0">Anda dapat menggunakan format berikut ini:</p>
                            <div className="row mt-2">
                              <div className="col-6 mb-2">
                                <p className="font-weight-semibold mb-0">• WAV (PCM Only)</p>
                              </div>
                              <div className="col-6 mb-2">
                                <p className="font-weight-semibold mb-0">• FLAC (Free Lossless Audio Codec)</p>
                              </div>
                              <div className="col-6 mb-2">
                                <p className="font-weight-semibold mb-0">• AIFF (Audio Interchange File Format)</p>
                              </div>
                              <div className="col-6 mb-2">
                                <p className="font-weight-semibold mb-0">• WMA (Lossless Only)</p>
                              </div>
                            </div>
                            <p className="text-white font-italic mt-3">
                              Anda dapat menyesuaikan berkas audio dengan trek Anda saat langkah penyerahan.
                            </p>
                         </div>
                    </div>
                  </div>
                </div>
              </fieldset>

              {/* Sunting Asset Step */}
              <fieldset className={`wizard-fieldset ${currentStep === 2 && "show"}`}>
                <h6 className="text-md text-neutral-500">Sunting Asset</h6>
                <div className="row gy-3">
                  <div className="mt-5">
                    <h3 className="text-lg font-semibold">Trek List</h3>
                    <div className="d-flex justify-content-end mt-4 gap-2">
                      <button
                        type="button"
                            className="btn btn-dark radius-8 px-20 py-11 d-flex align-items-center gap-2"
                        onClick={handleAddTrackClick}
                      >
                      <Icon icon="radix-icons:plus" className="text-xl" />
                        Tambah Trek
                      </button>
                      <button
                        type="button"
                            className="btn btn-dark radius-8 px-20 py-11 d-flex align-items-center gap-2"
                        onClick={handleAddUploadBulk}
                      >
                      <Icon icon="radix-icons:plus" className="text-xl" />
                        Upload Bulk Track
                      </button>
                    </div>
                  </div>
                    {/* Modal for Adding Trek */}
                    {isAdding && (
                      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 transition-all duration-300 ease-out animate-fadeIn">
                        <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-3xl p-6 relative">
                          <h2 className="text-2xl font-bold mb-4 mt-5 text-center">Tambah Trek</h2>
                          <div className="overflow-y-auto space-y-4 pr-2 p-5">
                            <div>
                              <label className="form-label">Jenis Trek Sekunder*</label>
                              <div className="d-flex gap-3">
                                {secondarySongType.map((type) => (
                                  <div key={type.secondary_song_type_code} className="form-check">
                                    <input
                                      type="checkbox"
                                      value={type.secondary_song_type_code}
                                      checked={newTrack.trackType.includes(type.secondary_song_type_code)}
                                      onChange={(e) => handleCheckboxChange(e, "trackType")}
                                      className="form-check-input"
                                      style={{'marginTop':'3px'}}
                                    />
                                    <label className="form-check-label" style={{'paddingLeft':'5px'}}>{type.secondary_song_type_name}</label>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* Instrumental Checkbox */}
                            <div>
                              <label className="form-label">Instrumental*</label>
                              <div className="d-flex gap-3">
                                {[{ value: true, name: "Ya" }, { value: false, name: "Tidak" }].map((type) => (
                                  <div key={type.name} className="form-check">
                                    <input
                                      type="checkbox"
                                      value={type.value}
                                      checked={newTrack.instruMental.includes(String(type.value))}
                                      onChange={(e) => handleCheckboxChange(e, "instruMental")}
                                      className="form-check-input"
                                      style={{'marginTop':'3px'}}
                                    />
                                    <label className="form-check-label" style={{'paddingLeft':'5px'}}>{type.name}</label>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* Input Fields */}
                            <div className="row gap-3">
                              <div className=" d-flex gap-2 col-md-12">
                                {/* Judul Lagu */}
                                <div className="col-md-6">
                                  <label className="form-label">Judul Lagu*</label>
                                  <input
                                    type="text"
                                    name="title"
                                    value={newTrack.title}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter Judul Lagu"
                                  />
                                </div>
                                {/* Versi/Anak Judul */}
                                <div className="col-md-6">
                                  <label className="form-label">Versi/Anak Judul</label>
                                  <input
                                    type="text"
                                    name="subtitle"
                                    value={newTrack.subtitle}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter Versi/Anak Judul"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Additional Fields */}
                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                                <div className="col-md-6">
                                  <label className="form-label">Artis Utama</label>
                                  <Select
                                    isMulti
                                    name="trackArtistMain"
                                    options={trackArtistMain || []}
                                    isLoading={!trackArtistMain}
                                    placeholder="Select Artist Main"
                                    value={(trackArtistMain || []).filter((opt) =>
                                      (newTrack?.trackArtistMain || []).includes(opt.value)
                                    )}
                                    onChange={(selectedOptions) =>
                                      handleInputChange({
                                        target: {
                                          name: 'trackArtistMain',
                                          value: selectedOptions.map((opt) => opt.value), // simpan sebagai array kode
                                        },
                                      })
                                    }
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Featuring</label>
                                  <Select
                                    isMulti
                                    name="trackFeaturing"
                                    options={trackFeaturing || []}
                                    isLoading={!trackFeaturing}
                                    placeholder="Select Artist Featuring"
                                    value={(trackFeaturing || []).filter((opt) =>
                                      (newTrack?.trackFeaturing || []).includes(opt.value)
                                    )}
                                    onChange={(selectedOptions) =>
                                      handleInputChange({
                                        target: {
                                          name: 'trackFeaturing',
                                          value: selectedOptions.map((opt) => opt.value), // simpan sebagai array kode
                                        },
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Genre and Other Fields */}
                            <div className="d-flex col-12 gap-3">
                            <div className="col-12">
                                <label className="form-label">Remixer</label>
                                <div className="d-flex align-items-center gap-2">
                                  <div className="flex-grow-1">
                                    <Select
                                      isMulti
                                      name="remixer"
                                      options={remixer || []}
                                      isLoading={!remixer}
                                      placeholder="Select Remixer"
                                      value={(remixer || []).filter((opt) =>
                                        (newTrack?.remixer || []).includes(opt.value)
                                      )}
                                      onChange={(selectedOptions) =>
                                        handleInputChange({
                                          target: {
                                            name: 'remixer',
                                            value: selectedOptions.map((opt) => opt.value),
                                          },
                                        })
                                      }
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    style={{
                                      outline: 'none',
                                      fontWeight: 'bold',
                                      fontSize: '27px',
                                      borderRadius: '20%',
                                      backgroundColor: '#487fff',
                                      color: 'white',
                                      width: '42px',
                                      height: '42px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      border: 'none',
                                    }}
                                    onClick={() => setOpenRemixer(true)} // Ganti handler sesuai kebutuhanmu
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                            
                            {openRemixer && (
                              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50 transition-all duration-300 ease-out animate-fadeIn">
                                <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-3xl p-6 relative transform transition-all scale-95 hover:scale-100 duration-300">
                                  <h2 className="text-2xl font-bold mb-4 mt-5 text-center">Tambah Remixer</h2>
                                  <form className="overflow-y-auto space-y-4 pr-2 p-5">
                                    {/* Input Fields */}
                                    <div className="row gap-3">
                                      <div className="d-flex gap-2 col-md-12">
                                        <div className="col-md-12">
                                          <label className="form-label">Remixer Name</label>
                                          <input
                                            type="text"
                                            name="remixerName"
                                            value={remixerFormData.remixerName}
                                            onChange={handleChangeRemixerForm}
                                            className="form-control"
                                            placeholder="Remixer Name"
                                          />
                                        </div>
                                        
                                      </div>
                                    </div>
                                    
                                    {/* Buttons */}
                                    <div className="d-flex justify-content-end gap-4 mt-10 pt-20 pb-12">
                                      <button
                                        type="button"
                                        onClick={handleCancelRemixerForm}
                                        className="btn w-100"
                                        style={{ backgroundColor: "#1f1f20", color: "white" }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        onClick={handleSaveRemixerForm}
                                        className="btn w-100"
                                        style={{ backgroundColor: "#487fff", color: "white" }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                          )}

                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                              <div className="col-md-6">
                                  <label className="form-label">Penulis</label>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="flex-grow-1">
                                      <Select
                                        isMulti
                                        name="writer"
                                        options={writer || []}
                                        isLoading={!writer}
                                        placeholder="Select Penulis"
                                        value={(writer || []).filter((opt) =>
                                          (newTrack?.writer || []).includes(opt.value)
                                        )}
                                        onChange={(selectedOptions) =>
                                          handleInputChange({
                                            target: {
                                              name: 'writer',
                                              value: selectedOptions.map((opt) => opt.value),
                                            },
                                          })
                                        }
                                      />
                                    </div>
                                    <button
                                      type="button"
                                      style={{
                                        outline: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '27px',
                                        borderRadius: '20%',
                                        backgroundColor: '#487fff',
                                        color: 'white',
                                        width: '42px',
                                        height: '42px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: 'none',
                                      }}
                                      onClick={() => setOpenWriter(true)}
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Composer</label>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="flex-grow-1">
                                      <Select
                                        isMulti
                                        name="composer"
                                        options={composer || []}
                                        isLoading={!composer}
                                        placeholder="Select Composer"
                                        value={(composer || []).filter((opt) =>
                                          (newTrack?.composer || []).includes(opt.value)
                                        )}
                                        onChange={(selectedOptions) =>
                                          handleInputChange({
                                            target: {
                                              name: 'composer',
                                              value: selectedOptions.map((opt) => opt.value),
                                            },
                                          })
                                        }
                                      />
                                    </div>
                                    <button
                                      type="button"
                                      style={{
                                        outline: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '27px',
                                        borderRadius: '20%',
                                        backgroundColor: '#487fff',
                                        color: 'white',
                                        width: '42px',
                                        height: '42px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: 'none',
                                      }}
                                      onClick={() => setOpenComposer(true)} // ganti sesuai handler yang kamu pakai
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {openWriter && (
                                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50 transition-all duration-300 ease-out animate-fadeIn">
                                  <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-3xl p-6 relative transform transition-all scale-95 hover:scale-100 duration-300">
                                    <h2 className="text-2xl font-bold mb-4 mt-5 text-center">Tambah Penulis</h2>
                                    <form className="overflow-y-auto space-y-4 pr-2 p-5">
                                      {/* Input Fields */}
                                      <div className="row gap-3">
                                        <div className="d-flex gap-2 col-md-12">
                                          <div className="col-md-12">
                                            <label className="form-label">Nama Penulis</label>
                                            <input
                                              type="text"
                                              name="writerName"
                                              value={writerFormData.writerName}
                                              onChange={handleChangeWriterForm}
                                              className="form-control"
                                              placeholder="Writer Name"
                                            />
                                          </div>
                                          
                                        </div>
                                      </div>
                                      
                                      {/* Buttons */}
                                      <div className="d-flex justify-content-end gap-4 mt-10 pt-20 pb-12">
                                        <button
                                          type="button"
                                          onClick={handleCancelWriterForm}
                                          className="btn w-100"
                                          style={{ backgroundColor: "#1f1f20", color: "white" }}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          type="button"
                                          onClick={handleSaveWriterForm}
                                          className="btn w-100"
                                          style={{ backgroundColor: "#487fff", color: "white" }}
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                            )}

                            {openComposer && (
                                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50 transition-all duration-300 ease-out animate-fadeIn">
                                  <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-3xl p-6 relative transform transition-all scale-95 hover:scale-100 duration-300">
                                    <h2 className="text-2xl font-bold mb-4 mt-5 text-center">Tambah Composer</h2>
                                    <form className="overflow-y-auto space-y-4 pr-2 p-5">
                                      {/* Input Fields */}
                                      <div className="row gap-3">
                                        <div className="d-flex gap-2 col-md-12">
                                          <div className="col-md-12">
                                            <label className="form-label">Composer Name</label>
                                            <input
                                              type="text"
                                              name="composerName"
                                              value={composerFormData.composerName}
                                              onChange={handleChangeComposerForm}
                                              className="form-control"
                                              placeholder="Composer Name"
                                            />
                                          </div>
                                          
                                        </div>
                                      </div>
                                      
                                      {/* Buttons */}
                                      <div className="d-flex justify-content-end gap-4 mt-10 pt-20 pb-12">
                                        <button
                                          type="button"
                                          onClick={handleCancelComposerForm}
                                          className="btn w-100"
                                          style={{ backgroundColor: "#1f1f20", color: "white" }}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          type="button"
                                          onClick={handleSaveComposerForm}
                                          className="btn w-100"
                                          style={{ backgroundColor: "#487fff", color: "white" }}
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                            )}

                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                              <div className="col-md-6">
                                  <label className="form-label">Arranger</label>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="flex-grow-1">
                                      <Select
                                        isMulti
                                        name="arranger"
                                        options={arranger || []}
                                        isLoading={!arranger}
                                        placeholder="Select Arranger"
                                        value={(arranger || []).filter((opt) =>
                                          (newTrack?.arranger || []).includes(opt.value)
                                        )}
                                        onChange={(selectedOptions) =>
                                          handleInputChange({
                                            target: {
                                              name: 'arranger',
                                              value: selectedOptions.map((opt) => opt.value),
                                            },
                                          })
                                        }
                                      />
                                    </div>
                                    <button
                                      type="button"
                                      style={{
                                        outline: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '27px',
                                        borderRadius: '20%',
                                        backgroundColor: '#487fff',
                                        color: 'white',
                                        width: '42px',
                                        height: '42px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: 'none',
                                      }}
                                      onClick={() => setOpenArranger(true)} // ubah handler sesuai kebutuhan
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Producer</label>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="flex-grow-1">
                                      <Select
                                        isMulti
                                        name="producer"
                                        options={producer || []}
                                        isLoading={!producer}
                                        placeholder="Select Producer"
                                        value={(producer || []).filter((opt) =>
                                          (newTrack?.producer || []).includes(opt.value)
                                        )}
                                        onChange={(selectedOptions) =>
                                          handleInputChange({
                                            target: {
                                              name: 'producer',
                                              value: selectedOptions.map((opt) => opt.value),
                                            },
                                          })
                                        }
                                      />
                                    </div>
                                    <button
                                      type="button"
                                      style={{
                                        outline: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '27px',
                                        borderRadius: '20%',
                                        backgroundColor: '#487fff',
                                        color: 'white',
                                        width: '42px',
                                        height: '42px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: 'none',
                                      }}
                                      onClick={() => setOpenProducer(true)} // ganti dengan handler milikmu
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {openArranger && (
                              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50 transition-all duration-300 ease-out animate-fadeIn">
                                <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-3xl p-6 relative transform transition-all scale-95 hover:scale-100 duration-300">
                                  <h2 className="text-2xl font-bold mb-4 mt-5 text-center">Tambah Arranger</h2>
                                  <form className="overflow-y-auto space-y-4 pr-2 p-5">
                                    {/* Input Fields */}
                                    <div className="row gap-3">
                                      <div className="d-flex gap-2 col-md-12">
                                        <div className="col-md-12">
                                          <label className="form-label">Arranger Name</label>
                                          <input
                                            type="text"
                                            name="arrangerName"
                                            value={arrangerFormData.arrangerName}
                                            onChange={handleChangeArrangerForm}
                                            className="form-control"
                                            placeholder="Arranger Name"
                                          />
                                        </div>
                                        
                                      </div>
                                    </div>
                                    
                                    {/* Buttons */}
                                    <div className="d-flex justify-content-end gap-4 mt-10 pt-20 pb-12">
                                      <button
                                        type="button"
                                        onClick={handleCancelArrangerForm}
                                        className="btn w-100"
                                        style={{ backgroundColor: "#1f1f20", color: "white" }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        onClick={handleSaveArrangerForm}
                                        className="btn w-100"
                                        style={{ backgroundColor: "#487fff", color: "white" }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            )}

                            {openProducer && (
                              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50 transition-all duration-300 ease-out animate-fadeIn">
                                <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-3xl p-6 relative transform transition-all scale-95 hover:scale-100 duration-300">
                                  <h2 className="text-2xl font-bold mb-4 mt-5 text-center">Tambah Producer</h2>
                                  <form className="overflow-y-auto space-y-4 pr-2 p-5">
                                    {/* Input Fields */}
                                    <div className="row gap-3">
                                      <div className="d-flex gap-2 col-md-12">
                                        <div className="col-md-12">
                                          <label className="form-label">Producer Name</label>
                                          <input
                                            type="text"
                                            name="producerName"
                                            value={producerFormData.producerName}
                                            onChange={handleChangeProducerForm}
                                            className="form-control"
                                            placeholder="Producer Name"
                                          />
                                        </div>
                                        
                                      </div>
                                    </div>
                                    
                                    {/* Buttons */}
                                    <div className="d-flex justify-content-end gap-4 mt-10 pt-20 pb-12">
                                      <button
                                        type="button"
                                        onClick={handleCancelProducerForm}
                                        className="btn w-100"
                                        style={{ backgroundColor: "#1f1f20", color: "white" }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        onClick={handleSaveProducerForm}
                                        className="btn w-100"
                                        style={{ backgroundColor: "#487fff", color: "white" }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            )}

                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                                <div className="col-md-6">
                                  <label className="form-label">P line</label>
                                  <input
                                    type="text"
                                    name="iInline"
                                    value={newTrack.iInline}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter P line"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Tahun Produksi*</label>
                                  <Select
                                    name="tahunProduksi"
                                    options={yearOptions}
                                    placeholder="Select Produksi"
                                    value={yearOptions.find((opt) => opt.value === newTrack.tahunProduksi)}
                                    onChange={(selectedOption) =>
                                      handleInputChange({
                                        target: {
                                          name: 'tahunProduksi',
                                          value: selectedOption ? selectedOption.value : '',
                                        },
                                      })
                                    }
                                    isClearable
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                                <div className="col-md-6">
                                  <label className="form-label">Pembuat</label>
                                  <input
                                    type="text"
                                    name="pembuat"
                                    value={newTrack.pembuat}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter Pembuat"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">ISRC</label>
                                  <input
                                    type="text"
                                    name="isrc"
                                    value={newTrack.isrc}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter ISRC"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row gap-3">
                              <div className="d-flex gap-2 col-md-12">
                                <div className="col-md-6">
                                  <label className="form-label">Genre</label>
                                  <Select
                                    options={genreOptions}
                                    value={newTrack.trackGenre}
                                    // onChange={(selected) =>
                                    //   setNewTrack((prev) => ({ ...prev, trackGenre: selected }))
                                    // }
                                    onChange={(selected) => {
                                      setNewTrack((prev) => ({
                                        ...prev,
                                        trackGenre: selected,
                                        trackSubGenre: selected ? prev.trackSubGenre : null, 
                                      }));
                                  
                                      if (!selected) {
                                        setSubGenreOptions([]); 
                                      }
                                    }}
                                    placeholder="Select Genre"
                                    isClearable
                                  />
                                </div>

                                <div className="col-md-6">
                                  <label className="form-label">Sub Genre</label>
                                  <Select
                                    options={subGenreOptions}
                                    value={newTrack.trackSubGenre}
                                    onChange={(selected) =>
                                      setNewTrack((prev) => ({ ...prev, trackSubGenre: selected }))
                                    }
                                    placeholder="Select Sub Genre"
                                    isClearable
                                    isDisabled={!newTrack.trackGenre}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row gap-3 mt-3">
                              <div className="d-flex gap-2 col-md-12">
                                <div className="col-md-6">
                                  <label className="form-label">Secondary Genre</label>
                                  <Select
                                    options={genreOptions}
                                    value={newTrack.trackSecGenre}
                                    // onChange={(selected) =>
                                    //   setNewTrack((prev) => ({ ...prev, trackSecGenre: selected }))
                                    // }
                                    onChange={(selected) => {
                                      setNewTrack((prev) => ({
                                        ...prev,
                                        trackSecGenre: selected,
                                        trackSecSubGenre: selected ? prev.trackSecSubGenre : null 
                                      }));
                                  
                                      if (!selected) {
                                        setSecSubGenreOptions([]); 
                                      }
                                    }}
                                    placeholder="Select Secondary Genre"
                                    isClearable
                                  />
                                </div>

                                <div className="col-md-6">
                                  <label className="form-label">Secondary Sub Genre</label>
                                  <Select
                                    options={secSubGenreOptions}
                                    value={newTrack.trackSecSubGenre}
                                    onChange={(selected) =>
                                      setNewTrack((prev) => ({ ...prev, trackSecSubGenre: selected }))
                                    }
                                    placeholder="Select Secondary Sub Genre"
                                    isClearable
                                    isDisabled={!newTrack.trackSecGenre}
                                  />
                                </div>
                              </div>
                            </div>
                              
                            <div className="row gap-3 mt-3">
                              {/* Nomor Katalog */}
                              <div className="d-flex col-12 gap-3">
                                <div className="col-12">
                                  <label className="form-label">Nomor Katalog</label>
                                  <input
                                    type="text"
                                    name="catalogNumber"
                                    value={newTrack.catalogNumber}
                                    className="form-control"
                                    placeholder="Enter Nomor Katalog"
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>

                              <div>
                                <label className="form-label">Bimbingan Orang Tua*</label>
                                <div className="d-flex gap-3">
                                  {[
                                    { value: "PG2503235049958", name: "Ya" },
                                    { value: "PG2503237142157", name: "Tidak" },
                                    { value: "PG2503232427252", name: "Cleaned" },
                                  ].map((type) => (
                                    <div key={type.value} className="form-check">
                                      <input
                                        type="checkbox"
                                        value={type.value}
                                        checked={
                                          Array.isArray(newTrack?.parentalGuidance) &&
                                          newTrack.parentalGuidance.includes(String(type.value))
                                        }
                                        onChange={(e) => handleCheckboxChange(e, "parentalGuidance")}
                                        className="form-check-input"
                                        style={{'marginTop':'3px'}}
                                      />
                                      <label className="form-check-label" style={{'paddingLeft':'5px'}}>{type.name}</label>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <div className="row gap-3">
                                <div className="d-flex gap-2 col-md-12">
                                  <div className="col-md-6">
                                    <label className="form-label">Pratinjau Mulai (MM:SS)</label>
                                    <input
                                      type="text"
                                      name="previewStart"
                                      value={newTrack.previewStart}
                                      onChange={handleInputChange}
                                      className="form-control"
                                      placeholder="Contoh: 02:25"
                                      pattern="^\d{2}:\d{2}$"
                                      maxLength={5}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <label className="form-label">Bahasa Judul Trek</label>
                                    <Select
                                      options={languageOptions}
                                      value={newTrack.titleLanguage}
                                      onChange={(selected) =>
                                        setNewTrack((prev) => ({ ...prev, titleLanguage: selected }))
                                      }
                                      placeholder="Select Bahasa Judul"
                                      isClearable
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex col-12 gap-3">
                                <div className="col-12">
                                  <label className="form-label">Bahasa Lirik</label>
                                  <Select
                                    options={languageOptions}
                                    value={newTrack.lyricLanguage}
                                    onChange={(selected) =>
                                      setNewTrack((prev) => ({ ...prev, lyricLanguage: selected }))
                                    }
                                    placeholder="Select Bahasa Lirik"
                                    isClearable
                                  />
                                </div>
                              </div>

                              {/* Nomor Katalog */}
                              <div className="d-flex col-12 gap-3">
                                <div className="col-12">
                                  <label className="form-label">Tambahkan lirik Track berikut</label>
                                  <textarea
                                    name="lyric"
                                    value={newTrack.lyric}
                                    className="form-control"
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>
                            </div>

                           
                          </div>
                           {/* Cancel and Save Buttons */}
                            <div className="d-flex justify-content-center gap-4 mt-4 pt-8 pb-5">
                              <button
                                type="button"
                                onClick={() => setIsAdding(false)}
                                className="btn btn-danger w-30"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                onClick={handleSaveTrack}
                                className="btn btn-dark w-30"
                              >
                                Save
                              </button>
                            </div>
                        </div>
                      </div>
                    )}

                    {/*Modal For Bulk Track */}
                    {
                      isAddingBulk && (
                        <div className="container fixed inset-0 mt-5">
                                <div className="row justify-content-center">
                                  <div className="col-md-8">
                                    <div className="card shadow-lg">
                                      <div
                                        className="card-header text-center"
                                        style={{
                                          background: "rgba(192, 219, 255, 0.45)", 
                                          backdropFilter: "blur(90px)", 
                                          color: "White",
                                          padding: "20px",
                                          borderRadius: "12px",
                                        }}
                                      >
                                        <h4>UPLOAD FILE</h4>
                                      </div>
                                      <div className="card-body">
                                        <p className="text-center">
                                          Select a file to upload and choose a Music Label below.
                                        </p>
                                        <div>
                                          {/* Dropdown Select Channel */}
                                          <div className="mb-3">
                                            <label className="form-label">Select Music Label</label>
                                           <input
                                              type="text"
                                              id="musiclabelcode"
                                              className="form-control"
                                              value={musicLabelName}
                                              readOnly 
                                              required
                                            />
                                          </div>
                            
                                          {/* File Upload */}
                                          <div className="mb-3">
                                            <label className="form-label">Choose File</label>
                                            <input
                                              required
                                              type="file"
                                              className="form-control"
                                              ref={fileInputBulkRef}
                                              onChange={handleFileBulkChange}
                                            />
                                          </div>
                            
                                          {/* Upload Button */}
                                          <div className="d-flex justify-content-center gap-2">
                                            <button
                                            type="button"
                                            onClick={() => setIsAddingBulk(false)}
                                            className="btn btn-danger cursor-pointer"
                                          >
                                            Cancel
                                          </button>
                                          <button className="btn btn-primary cursor-pointer" type='submit'
                                          onClick={handleSaveTrackBulk}
                                          >
                                              <i className="ri-upload-cloud-line me-4"></i>
                                              Upload
                                          </button>
                                        </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                      )
                    }

                    {/* Track List Table */}
                    {trackList.length === 0 && (
                      <p className="text-gray-600 text-sm mt-4">Belum ada trek yang ditambahkan.</p>
                    )}
                    {trackList.length > 0 && (
                      <table className="table table-bordered mt-4">
                        <thead>
                          <tr className="bg-dark text-white">
                            <th className="text-center">No</th>
                            <th className="text-center">Judul</th>
                            <th className="text-center">Sub Judul</th>
                            {/* <th>Content Type</th> */}
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {trackList.map((track, index) => (
                            <tr key={index}>
                              <td className="text-center">{index + 1}</td>
                              <td className="text-left">{track.title}</td>
                              <td className="text-left">{track.subtitle}</td>
                              {/* <td className="text-center">{track.contentType.join(", ")}</td> */}
                              <td className="justify-content-center d-flex gap-2">
                                <button
                                  type="button"
                                  onClick={() => handleEditTrack(index)}
                                  className="btn btn-dark btn-sm"
                                >
                                  Edit
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDeleteTrack(index)}
                                  className="btn btn-danger btn-sm"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                </div>
              </fieldset>

              {/* Teritori Step */}
              {/* <fieldset className={`wizard-fieldset ${currentStep === 3 && "show"}`}>
                <h6 className="text-md text-neutral-500">Teritori</h6>
                <div className="row gy-3">
                  <div className="col-sm-6">
                    <label className="form-label">Country*</label>
                    <input
                      type="text"
                      className="form-control wizard-required"
                      placeholder="Enter Country"
                      name="Teritori.country"
                      value={formData.Teritori.country}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </fieldset> */}

              {/* Tanggal Rilis Step */}
              {/* <fieldset className={`wizard-fieldset ${currentStep === 4 && "show"}`}>
                <h6 className="text-md text-neutral-500">Tanggal Rilis</h6>
                <div className="row gy-3">
                  <div className="col-sm-6">
                    <label className="form-label">Release Date*</label>
                    <input
                      type="date"
                      className="form-control wizard-required"
                      name="TanggalRilis.releaseDate"
                      value={formData.TanggalRilis.releaseDate}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </fieldset> */}

              {/* Promosi Step */}
              {/* <fieldset className={`wizard-fieldset ${currentStep === 5 && "show"}`}>
                <h6 className="text-md text-neutral-500">Promosi</h6>
                <div className="row gy-3">
                  <div className="col-sm-6">
                    <label className="form-label">Promo Information*</label>
                    <input
                      type="text"
                      className="form-control wizard-required"
                      placeholder="Enter Promo Info"
                      name="Promosi.promoInfo"
                      value={formData.Promosi.promoInfo}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </fieldset> */}

              {/* Tanggal Penyerahan Step */}
              {/* <fieldset className={`wizard-fieldset ${currentStep === 6 && "show"}`}>
                <h6 className="text-md text-neutral-500">Tanggal Penyerahan</h6>
                <div className="row gy-3">
                  <div className="col-sm-6">
                    <label className="form-label">Submission Date*</label>
                    <input
                      type="date"
                      className="form-control wizard-required"
                      name="TanggalPenyerahan.submitDate"
                      value={formData.TanggalPenyerahan.submitDate}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </fieldset> */}

              {/* Preview Step */}
              <fieldset className={`wizard-fieldset ${currentStep === 3 && "show"}`}>
                {/* {currentStep === 7 && (
                  <div className="preview-container">
                    <h5>Preview of All Data</h5>
                    <div className="preview-content">
                      <div className="preview-item">
                        <strong>Title:</strong> {formData.RilisTerbaru.title || 'Not Provided'}
                      </div>
                      <div className="preview-item">
                        <strong>Version:</strong> {formData.RilisTerbaru.versi || 'Not Provided'}
                      </div>
                      <div className="preview-item">
                        <strong>Email:</strong> {formData.RilisTerbaru.email || 'Not Provided'}
                      </div>
                      <div className="preview-item">
                        <strong>Artist:</strong> {formData.RilisTerbaru.artis || 'Not Provided'}
                      </div>
                      <div className="preview-item">
                        <strong>Genre:</strong> {formData.RilisTerbaru.genre || 'Not Provided'}
                      </div>
                      <div className="preview-item">
                        <strong>Label:</strong> {formData.RilisTerbaru.label || 'Not Provided'}
                      </div>
                      <div className="preview-item">
                        <strong>Release Date:</strong> {formData.RilisTerbaru.releaseDate || 'Not Provided'}
                      </div>
                      <div className="preview-item">
                        <strong>Cover Image:</strong>
                        {formData.coverImage ? (
                          <img src={URL.createObjectURL(formData.coverImage)} alt="Cover" style={{ maxWidth: '150px' }} />
                        ) : (
                          "No image uploaded"
                        )}
                      </div>
                      {trackList.length > 0 && (
                            <div className="preview-item">
                              <strong>Track List:</strong>
                              <ul>
                                {trackList.map((track, index) => (
                                  <li key={index}>
                                    <div><strong>Track {index + 1}:</strong></div>
                                    <div>Title: {track.title}</div>
                                    <div>Subtitle: {track.subtitle}</div>
                                    <div>Content Type: {track.contentType.join(", ")}</div>
                                    <div>Artist: {track.artisUtama}</div>
                                    <div>Featuring: {track.featuring}</div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                            )}
                          </div>
                        </div>
                )} */}
                {
                  currentStep === 3 && renderPreview()}
              </fieldset>

              {/* Buttons */}
              <div className="form-group d-flex align-items-center justify-content-end gap-8 mt-3">
                {currentStep > 1 && (
                  <button onClick={prevStep} type="button" className="form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32">
                    Back
                  </button>
                )}
                {currentStep === 3 ? (
                  <button type="button" onClick={handleCreateRelease} className="form-wizard-submit btn btn-primary-600 px-32"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Menyimpan..." : "Submit"}
                    
                  </button>
                ) : (
                  <button onClick={nextStep} type="button" className="form-wizard-next-btn btn btn-primary-600 px-32">Next</button>
                )}
              </div>
              {modal}
              {isLoading && <LottieLoading text="Loading..." />}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormStepRilis;
